"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataRequestSaga = dataRequestSaga;
exports.dataWatcher = dataWatcher;

var _effects = require("redux-saga/effects");

var _apiRequest = require("../api/apiRequest");

var _actions = require("../../data/value/actions");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var _selectors = require("../../data/views/selectors");

var _lodash = _interopRequireDefault(require("lodash"));

var _selectors2 = require("../../filters/value/selectors");

var _selectors3 = require("../../data/filters/selectors");

var _component = require("../../../constants/component");

var _selectors4 = require("../../locale/selectors");

var _AbortError = require("../../../common/errors/AbortError");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(dataRequestSaga),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadData),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(dataWatcher);

var ABORT_CONTROLLERS_PER_TYPE = {};

function dataRequestSaga(dataType, abortController) {
  var url, dataMapping, method, state, requestParams, relatedDataViews, dataViewFilters, rawData, data;
  return regeneratorRuntime.wrap(function dataRequestSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          url = dataType.url;

          dataMapping = dataType.mapping || function (data) {
            return data;
          };

          method = dataType.method || "POST";

          if (ABORT_CONTROLLERS_PER_TYPE.hasOwnProperty(dataType.type) && ABORT_CONTROLLERS_PER_TYPE[dataType.type] instanceof AbortController) {
            // Abort prev request
            ABORT_CONTROLLERS_PER_TYPE[dataType.type].abort();
          }

          ABORT_CONTROLLERS_PER_TYPE[dataType.type] = abortController;

          if (url) {
            _context.next = 8;
            break;
          }

          throw new Error("Wrong data source url `" + url + "` for data type `" + dataType + "`");

        case 8:
          _context.next = 10;
          return (0, _effects.put)(actions.request(dataType.type));

        case 10:
          _context.next = 12;
          return (0, _effects.select)();

        case 12:
          state = _context.sent;
          // Prepare request params ...
          requestParams = Object.assign({}, dataType.queryParams || {}); // ... assign data related filters

          relatedDataViews = (0, _selectors.getDataViewsByDataType)(state, dataType);

          _lodash["default"].forEach(relatedDataViews, function (dataView) {
            if (dataView[_component.PROPS.FILTER_TYPE]) {
              _lodash["default"].merge(requestParams, (0, _selectors2.getValue)(state, dataView[_component.PROPS.FILTER_TYPE]));
            }

            _lodash["default"].forEach(dataView[_component.PROPS.RELATED_FILTERS], function (filterType) {
              _lodash["default"].merge(requestParams, (0, _selectors2.getValue)(state, filterType));
            });
          }); // ... assign self data view filters


          dataViewFilters = (0, _selectors3.getValue)(state, dataType.type);

          _lodash["default"].merge(requestParams, dataViewFilters);

          rawData = "";

          if (!(method === "GET")) {
            _context.next = 25;
            break;
          }

          _context.next = 22;
          return (0, _effects.call)(_apiRequest.apiRequest, url, "GET", {
            query: requestParams,
            locale: (0, _selectors4.getLocale)(state)
          }, abortController ? abortController.signal : undefined);

        case 22:
          rawData = _context.sent;
          _context.next = 28;
          break;

        case 25:
          _context.next = 27;
          return (0, _effects.call)(_apiRequest.apiRequest, url, "POST", {
            body: requestParams,
            locale: (0, _selectors4.getLocale)(state)
          }, abortController ? abortController.signal : undefined);

        case 27:
          rawData = _context.sent;

        case 28:
          data = dataMapping(rawData);
          _context.next = 31;
          return (0, _effects.put)(actions.success(dataType.type));

        case 31:
          delete ABORT_CONTROLLERS_PER_TYPE[dataType.type];
          return _context.abrupt("return", data);

        case 35:
          _context.prev = 35;
          _context.t0 = _context["catch"](0);

          if (_context.t0 instanceof _AbortError.AbortError) {
            _context.next = 41;
            break;
          }

          console.error(_context.t0);
          _context.next = 41;
          return (0, _effects.put)(actions.failure(dataType.type));

        case 41:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 35]]);
}

function loadData(action) {
  var _action$payload, dataType, abortController, data;

  return regeneratorRuntime.wrap(function loadData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, dataType = _action$payload.dataType, abortController = _action$payload.abortController;

          if (!(dataType !== undefined)) {
            _context2.next = 7;
            break;
          }

          _context2.next = 4;
          return (0, _effects.call)(dataRequestSaga, dataType, abortController);

        case 4:
          data = _context2.sent;
          _context2.next = 7;
          return (0, _effects.put)((0, _actions.setValue)(dataType, data));

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function dataWatcher() {
  return regeneratorRuntime.wrap(function dataWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, loadData);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}